<google-map height="100%" width="100%" [center]="origin" [zoom]="16">
    <map-directions-renderer *ngIf="directions" [options]="rendererOptions"
        [directions]="directions"></map-directions-renderer>
    <map-marker #mapMarker="mapMarker" *ngFor="let marker of markers" [position]="marker.position"
        [label]="marker.label" [title]="marker.title" (mapClick)="markerClick(mapMarker,marker)">

    </map-marker>
    <map-info-window>{{selectedMarker?.title}}</map-info-window>

</google-map>